import Plyr from 'plyr';
import { gsap } from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {debounce} from 'throttle-debounce';

import сustomPageScroll from '../custom-scroll';
import {splitTitle} from "../letters";
// import { pauseHeroGradient } from './hero';

import initScrollTrigger from '../../helpers/initScrollTrigger';
// import intarpolateProgress from '../../helpers/interpolate';
import { scaleBlockToScreen } from '../../helpers/video-helpers';
import scrollTo from '../../helpers/scrollTo';
import { DOM, CLASSES, IS_TOUCH, IS_HOME_VERTICAL, IS_PHONE, IS_CHROME, IS_SAFARI, IS_FIREFOX } from '../../helpers/consts';

gsap.registerPlugin(ScrollTrigger);

// const textSection = document.querySelector('.js-home-text-section');
// let videoSectionIndex = textSection ? 2 : 1;
let videoSectionIndex = 0;
const initVideo = () => {
	const videoBlock = document.querySelector('.js-home-media-block');
	const video = document.querySelector('.js-home-media');
	const volumeBtn = document.querySelector('.js-home-video-volume-btn');
	if(!video || !videoBlock) return;

	const contronls = IS_PHONE ? ['play','progress', 'volume'] : []
	const player = new Plyr(video, {
		ratio: '16:9',
		muted: true,
		autoplay: false,
		controls: contronls,
		vimeo: {
			loop: false,
			background: true,
			transparency: true,
			autoplay: false,
			muted: true,
		}
	});

	player.on('ready', () => {
		player.muted = true;
		// console.log(`ready`)
		// player.play();

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if(entry.isIntersecting) {
					// console.log(`play`)
					player.play();
				}
				else {
					// console.log(`pause`)
					player.pause();
				}
			});
		}, { threshold: 0 });
		observer.observe(videoBlock);
	});


	if(!IS_HOME_VERTICAL) {
		scaleBlockToScreen(videoBlock);
	};

	const volumeIcon = volumeBtn.querySelectorAll('.btn-volume__svg_icon');

	volumeBtn.addEventListener('click', () => {

		volumeIcon.forEach(svg => svg.classList.toggle('is-hidden'));

		if(player.muted) {
			player.muted = false;
			player.volume = 1;
		}
		else {
			player.muted = true;
			player.volume = 0;
		}
	});
	return player;
};

const homeSections = document.querySelectorAll('.js-home-section');

const getHorDistanceToSection = (sectionIndex, toEnd = false, isPrevScrolling = false) => {
	let distance = 0;
	const ww = document.documentElement.clientWidth;
	const wh = document.documentElement.clientHeight;

	homeSections.forEach((section, i) => {
		const isHorizontal = section.classList.contains('is-horizontal-section');
		const rect = section.getBoundingClientRect();
		if(i < sectionIndex) {
			if(isHorizontal) {
				distance = distance + Math.ceil(rect.width);
			}
			// else {
			// 	distance = distance + rect.height;
			// }
		}
		if(toEnd && i === sectionIndex) {
			distance = distance + rect.width - ww;
		}
	});

	return distance;
};

const initVericalFunctional = () => {
	initVideo();
}

export default () => {
	if(IS_HOME_VERTICAL) {
		initVericalFunctional()
		return
	};


	DOM.header.classList.add('is-special-close-btn');
	initScrollTrigger();

	const videoTextSection = document.querySelector('.js-home-video-text-section');
	if(!videoTextSection)	return;

	const player = initVideo();
	// const videoTextMain = document.querySelector('.js-home-video-text-main');
	const textBlock = document.querySelector('.js-home-text-screen');
	const closeVideoBtn = document.querySelector('.js-home-video-close');
	const clipElem = document.querySelector('#video-circle-mask');
	const title = document.querySelector('.js-home-text-screen-title');

	splitTitle(title)

	let scrollId = null;
	let tl = null;
	let maskSize = 150;
	const ww = document.documentElement.clientWidth;
	maskSize = ww > 1920 ? 350 : maskSize;


	let startScale =  ww > 1920 ? 25 : 15;
	startScale = IS_FIREFOX ? 20 : startScale;
	startScale = IS_FIREFOX && ww > 1920 ? 40 : startScale;
	startScale = IS_CHROME ? 20 : startScale;
	startScale = IS_CHROME && ww > 1920 ? 40 : startScale;

	let transformOrigin = IS_SAFARI ? '50% 50%' : '50% 50%';
	transformOrigin = IS_FIREFOX ? '70% 70%' : transformOrigin;
	transformOrigin = IS_CHROME ? '70% 70%' : transformOrigin;

	const initAnimTimeline = () => {
		tl = new gsap.timeline({
			paused: true,
			onStart: () => {
				textBlock.classList.add(CLASSES.active)

			},
			onComplete: () => {
				if(player) player.pause();
				сustomPageScroll.enableScroll();
				title.classList.add('is-animated');
				DOM.header.classList.remove('is-special-close-btn');
			}
		});

		tl.fromTo(clipElem, {
			transformOrigin: transformOrigin,
			x: () => {
				const ww = document.documentElement.clientWidth;
				let val = ww - maskSize - ww*0.1

				if(IS_SAFARI) {
					val = -maskSize * startScale
				}
				return val;
			},
			y: () => {
				const wh = document.documentElement.clientHeight;
				let val = wh/2 - maskSize/2

				if(IS_SAFARI) {
					val = -maskSize * startScale
				}
				return val;
			},
			scale: startScale,
			duration: 0.7,
		}, {
			transformOrigin: transformOrigin,
			x: () => {
				const ww = document.documentElement.clientWidth;
				let val = ww - maskSize - ww*0.1

				if(IS_SAFARI) {
					val = ww - maskSize
				}
				return val;
			},
			y: () => {
				const wh = document.documentElement.clientHeight;
				let val = wh/2 - maskSize/2

				if(IS_SAFARI) {
					val = wh/2 + maskSize/3
				}
				return val;
			},
			scale: 0,
			duration: 0.7,
		});
	};

	initAnimTimeline();


	gsap.to("#fade-out-div", {
		scrollTrigger: {
			trigger: "#fade-out-div",
			// Adding a slight offset to delay the start of the fade-out
			// Assuming the viewport width is similar to the div width,
			// we shift the start point a bit to the left (outside of the viewport)
			start: () => `right right`,
			// Ends when the left edge of the div is just out of the right edge of the viewport
			end: () => `right left`,
			scrub: true,
			horizontal: true,
			onEnterBack: () => gsap.to("#fade-out-div", { opacity: 1 }), // Reset to fully visible when scrolling back
		},
		opacity: 0, // Target opacity level
		ease: "none"
	});



	const animateToTextView = () => {
		if(сustomPageScroll.isGlobalScrolling) return;
		clearInterval(scrollId);

		if(tl) tl.play();
	};

	if(closeVideoBtn) {
		closeVideoBtn.addEventListener('click', () => {
			animateToTextView();
		});
	}

	player.on('ended', function() {
		// console.log('end video');
		animateToTextView();
	});

	// let scrollProgress = 0;

	// const setAnimState = (self) => {
	// 	const progress = self.progress;
	// 	const distance = videoTextSection.offsetWidth - videoTextMain.offsetWidth;

	// 	if(progress  > scrollProgress ) {
	// 		scrollProgress = progress;
	// 	}
	// 	else {
	// 		сustomPageScroll.disableScroll();
	// 		const distance = getHorDistanceToSection(videoSectionIndex, true);

	// 		setTimeout(() => {
	// 			scrollTo(distance, 0, 30, () => {
	// 				сustomPageScroll.enableScroll();
	// 			});
	// 		}, 100);
	// 	}
	// 	gsap.set(videoTextMain, {
	// 		x: distance * progress,
	// 		force3D: true,
	// 	});
	// };

	// const videoTrigger = ScrollTrigger.create({
	// 	trigger: videoTextSection,
	// 	horizontal: true,
	// 	start: 'left left',
	// 	// pinnedContainer: videoTextMain,
	// 	// pin: true,
	// 	// pinSpacer: false,
	// 	onEnter: () => {
	// 		console.log('video enter');
	// 		// videoTextSection.classList.add('is-control-view');
	// 		// сustomPageScroll.disableScroll();

	// 		scrollId = setInterval(() => {
	// 			if(!сustomPageScroll.isGlobalScrolling) {
	// 				clearInterval(scrollId);
	// 				const distance = getHorDistanceToSection(videoSectionIndex, true);
	// 				scrollTo(distance, 0, 30);
	// 			}
	// 		}, 30);
	// 	},
	// 	onUpdate: setAnimState,
	// 	end: () => {
	// 		return `+=${videoTextSection.offsetWidth - videoTextMain.offsetWidth}`;
	// 	},
	// });

	videoTextSection.classList.add('is-control-view');
};
